module.exports = __webpack_public_path__ + "static/media/icon-select-on.f1ee0aa3.svg";